export default __webpack_public_path__ + "static/media/cdph.70b875cc.png";